<script>
import utils from '@/utils/common';

import TaskViewChecklistPopup from './TaskViewChecklistPopup.vue';

export default {
  name: 'TaskViewCheckListDispatcher',
  components: { TaskViewChecklistPopup },
  props: {
    action: String,
    tasks: Array,
    isOpened: Boolean,
  },
  computed: {
    changedTasksWord() {
      return utils.pluralWord(this.tasks.length, 'задаче', 'задачах', 'задачах');
    },

    question() {
      return {
        new_description: 'Чек-листы в выбранных задачах будут удалены, и в них будет установлен текущий чек-лист. Данное действие невозможно отменить. Вы уверены, что хотите сделать это?',
        empty_description: 'Чек-листы в выбранных задачах будут удалены. Данное действие невозможно отменить. Вы уверены, что хотите сделать это?',
      };
    },
  },
  methods: {
    async submit(value) {
      const question = value.length ? this.question.new_description : this.question.empty_description;
      const text = value.length > 0 ? 'Чек-лист изменён' : 'Чек-лист удалён';

      if (await this.$confirm(question)) {
        this.$emit('submit', { result: { [this.action]: value }, onSuccess: () => { this.$push({ text }); } });
      }
    },
  },
};
</script>

<template lang="pug">
TaskViewChecklistPopup(v-if="isOpened" @submit="submit" @close="$emit('close')")
</template>

<style scoped lang="scss">

</style>
